import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Modal, Space } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from "react";
import { getFileExtension, getFilePath, getPreviewUrl, isImagePreviewType, isShowable } from "../../../library/constants";
import { PDFViewer } from '../../../library/utilities/PDFviewer';
import { formatDateTime } from '../../../library/utilities/intl.js';
import { Image } from "../../../ui";
import style from './received-artwork.module.scss';

const DocumentsDownloader = ({ image, name, comment, project_id, containerStyles, uploadedAt }) => {
    const [isModalOpen, setisOpen] = useState(false)
    const fileType = getFileExtension(image)
    const isPreviewable = isShowable(image)
    const isImagePreview = isImagePreviewType(fileType)
    const modalBodyStyles = { padding: 0, display: 'flex', justifyContent: 'center' }
    const modalWidth = isImagePreview ? 'fit-content' : 'min(92vw, 1100px)'
    const modalStyles = { maxWidth: 'calc(100vw - 32px)', width: modalWidth }
    return (<div className={style.itemDetail} style={containerStyles}>
        <div className={style.bottomButton}>
            <Image src={getPreviewUrl(image, project_id)} width="100" className={style.imageBox} />
            <div className={style.imageName}>
                <h4>{name}</h4>
                {!!uploadedAt && <p style={{ color: '#8c8c8c', fontSize: '0.8rem', margin: '0 0 4px' }}>{formatDateTime(uploadedAt)}</p>}
                {comment != undefined && <p><b>Comment</b> : {comment}</p>}
                <Space.Compact>
                    <a href={getFilePath(image, project_id)} download="image.png"> <Button icon={<DownloadOutlined />} >Download</Button> </a>
                    {isPreviewable && <Button icon={<EyeOutlined />} onClick={() => { setisOpen(true) }}>View</Button>}
                </Space.Compact>
            </div>
        </div>
        <Modal title="Preview" open={isModalOpen} onCancel={() => { setisOpen(false) }} footer={<Button onClick={() => { setisOpen(false) }} >Close</Button>} width={modalWidth} style={modalStyles} bodyStyle={modalBodyStyles} centered>
            <PDFViewer path={image} project_id={project_id} type={fileType} />
        </Modal>
    </div>)
}

DocumentsDownloader.propTypes = {
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    comment: PropTypes.string,
    project_id: PropTypes.number,
    containerStyles: PropTypes.object,
    // When the file was uploaded/generated (ISO string or epoch ms)
    uploadedAt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default DocumentsDownloader
